import gql from 'graphql-tag';

export default gql`
  query GetGhdSocialNetworks {
    getGhdSocialNetworks {
      id
      name
      url
      updated_at
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/graphql/ghd-social-network/getGhdSocialNetworks.js